"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleCache = void 0;
class SimpleCache {
    constructor(factory) {
        this.factory = factory;
        this.map = new Map();
    }
    getOrCreate(key, onCreate) {
        const cached = this.map.get(key);
        if (cached !== undefined) {
            return cached;
        }
        const created = this.factory(key);
        this.map.set(key, created);
        onCreate === null || onCreate === void 0 ? void 0 : onCreate(created);
        return created;
    }
}
exports.SimpleCache = SimpleCache;
